
// @ts-nocheck


export const localeCodes =  [
  "de",
  "en",
  "es",
  "fr",
  "it",
  "nl",
  "pt"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_241d6561",
      load: () => import("#nuxt-i18n/241d6561" /* webpackChunkName: "locale_de_46json_241d6561" */),
      cache: true
    },
    {
      key: "locale_de_46json_d7f9ac57",
      load: () => import("#nuxt-i18n/d7f9ac57" /* webpackChunkName: "locale_de_46json_d7f9ac57" */),
      cache: true
    },
    {
      key: "locale_de_46json_766561a9",
      load: () => import("#nuxt-i18n/766561a9" /* webpackChunkName: "locale_de_46json_766561a9" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_8e6ec66e",
      load: () => import("#nuxt-i18n/8e6ec66e" /* webpackChunkName: "locale_en_46json_8e6ec66e" */),
      cache: true
    },
    {
      key: "locale_en_46json_2f78f4ba",
      load: () => import("#nuxt-i18n/2f78f4ba" /* webpackChunkName: "locale_en_46json_2f78f4ba" */),
      cache: true
    },
    {
      key: "locale_en_46json_2896ac0c",
      load: () => import("#nuxt-i18n/2896ac0c" /* webpackChunkName: "locale_en_46json_2896ac0c" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_476cfa2f",
      load: () => import("#nuxt-i18n/476cfa2f" /* webpackChunkName: "locale_es_46json_476cfa2f" */),
      cache: true
    },
    {
      key: "locale_es_46json_cf794b02",
      load: () => import("#nuxt-i18n/cf794b02" /* webpackChunkName: "locale_es_46json_cf794b02" */),
      cache: true
    },
    {
      key: "locale_es_46json_ed9ff0db",
      load: () => import("#nuxt-i18n/ed9ff0db" /* webpackChunkName: "locale_es_46json_ed9ff0db" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_659ec961",
      load: () => import("#nuxt-i18n/659ec961" /* webpackChunkName: "locale_fr_46json_659ec961" */),
      cache: true
    },
    {
      key: "locale_fr_46json_f38b6677",
      load: () => import("#nuxt-i18n/f38b6677" /* webpackChunkName: "locale_fr_46json_f38b6677" */),
      cache: true
    },
    {
      key: "locale_fr_46json_ab55f907",
      load: () => import("#nuxt-i18n/ab55f907" /* webpackChunkName: "locale_fr_46json_ab55f907" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_5ffd1e7e",
      load: () => import("#nuxt-i18n/5ffd1e7e" /* webpackChunkName: "locale_it_46json_5ffd1e7e" */),
      cache: true
    },
    {
      key: "locale_it_46json_36a148f8",
      load: () => import("#nuxt-i18n/36a148f8" /* webpackChunkName: "locale_it_46json_36a148f8" */),
      cache: true
    },
    {
      key: "locale_it_46json_f2a071cd",
      load: () => import("#nuxt-i18n/f2a071cd" /* webpackChunkName: "locale_it_46json_f2a071cd" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_14e6e17d",
      load: () => import("#nuxt-i18n/14e6e17d" /* webpackChunkName: "locale_nl_46json_14e6e17d" */),
      cache: true
    },
    {
      key: "locale_nl_46json_f8cf21fc",
      load: () => import("#nuxt-i18n/f8cf21fc" /* webpackChunkName: "locale_nl_46json_f8cf21fc" */),
      cache: true
    },
    {
      key: "locale_nl_46json_bc988112",
      load: () => import("#nuxt-i18n/bc988112" /* webpackChunkName: "locale_nl_46json_bc988112" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_97a4f51f",
      load: () => import("#nuxt-i18n/97a4f51f" /* webpackChunkName: "locale_pt_46json_97a4f51f" */),
      cache: true
    },
    {
      key: "locale_pt_46json_50e36c84",
      load: () => import("#nuxt-i18n/50e36c84" /* webpackChunkName: "locale_pt_46json_50e36c84" */),
      cache: true
    },
    {
      key: "locale_pt_46json_19ad9a7c",
      load: () => import("#nuxt-i18n/19ad9a7c" /* webpackChunkName: "locale_pt_46json_19ad9a7c" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "localeDetector.ts",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de",
      language: "de-DE",
      name: "Deutsch",
      files: [
        {
          path: "/usr/src/app/shared/contact-form/i18n/locales/de.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/shared/common/i18n/locales/de.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/apps/frontend/www/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      language: "en-US",
      name: "English",
      files: [
        {
          path: "/usr/src/app/shared/contact-form/i18n/locales/en.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/shared/common/i18n/locales/en.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/apps/frontend/www/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es-ES",
      name: "Español",
      files: [
        {
          path: "/usr/src/app/shared/contact-form/i18n/locales/es.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/shared/common/i18n/locales/es.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/apps/frontend/www/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr-FR",
      name: "Français",
      files: [
        {
          path: "/usr/src/app/shared/contact-form/i18n/locales/fr.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/shared/common/i18n/locales/fr.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/apps/frontend/www/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      language: "it-IT",
      name: "Italiano",
      files: [
        {
          path: "/usr/src/app/shared/contact-form/i18n/locales/it.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/shared/common/i18n/locales/it.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/apps/frontend/www/i18n/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      language: "nl-NL",
      name: "Dutch",
      files: [
        {
          path: "/usr/src/app/shared/contact-form/i18n/locales/nl.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/shared/common/i18n/locales/nl.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/apps/frontend/www/i18n/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      language: "pt-PT",
      name: "Português",
      files: [
        {
          path: "/usr/src/app/shared/contact-form/i18n/locales/pt.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/shared/common/i18n/locales/pt.json",
          cache: undefined
        },
        {
          path: "/usr/src/app/apps/frontend/www/i18n/locales/pt.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "fr",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://www.quotatrip.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de",
    language: "de-DE",
    name: "Deutsch",
    files: [
      {
        path: "/usr/src/app/shared/contact-form/i18n/locales/de.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/shared/common/i18n/locales/de.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/apps/frontend/www/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en-US",
    name: "English",
    files: [
      {
        path: "/usr/src/app/shared/contact-form/i18n/locales/en.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/shared/common/i18n/locales/en.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/apps/frontend/www/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es-ES",
    name: "Español",
    files: [
      {
        path: "/usr/src/app/shared/contact-form/i18n/locales/es.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/shared/common/i18n/locales/es.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/apps/frontend/www/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    files: [
      {
        path: "/usr/src/app/shared/contact-form/i18n/locales/fr.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/shared/common/i18n/locales/fr.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/apps/frontend/www/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    language: "it-IT",
    name: "Italiano",
    files: [
      {
        path: "/usr/src/app/shared/contact-form/i18n/locales/it.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/shared/common/i18n/locales/it.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/apps/frontend/www/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    language: "nl-NL",
    name: "Dutch",
    files: [
      {
        path: "/usr/src/app/shared/contact-form/i18n/locales/nl.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/shared/common/i18n/locales/nl.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/apps/frontend/www/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    language: "pt-PT",
    name: "Português",
    files: [
      {
        path: "/usr/src/app/shared/contact-form/i18n/locales/pt.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/shared/common/i18n/locales/pt.json",
        cache: undefined
      },
      {
        path: "/usr/src/app/apps/frontend/www/i18n/locales/pt.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/